// @flow
import styled, { type StyledComponent } from 'styled-components'
import { linkColor, alertColor } from '../controls/colors'

export function clearFix() {
  return `
    &:after {
      display: table;
      content: '';
      clear: both;
    }
  `
}

export function blueLinkDashed() {
  return `
    border-bottom: 1px dashed #61b8d3;
    color: ${linkColor};
    text-decoration: none;
    margin: 0 10px;
    padding: 10px 0 0 0;
    font-weight: normal;
    float: none;
    height: auto;
    &:hover {
      color: ${alertColor};
      border-color: ${alertColor};
    }
  `
}

const Header: StyledComponent<Object, any, any> = styled.div`
  font-size: 20px;
  color: #000;
  font-weight: bold;
  text-align: left;
  margin: 40px 0 25px;
  padding: 0;
  box-sizing: border-box;
`

const ClearFix: StyledComponent<Object, any, any> = styled.div`
  ${clearFix()};
`

const LoaderPreviewBlock: StyledComponent<Object, any, any> = styled.div`
  ${clearFix()};
  float: left;
  position: relative;
  margin-right: 5px;
`

export { Header, ClearFix, LoaderPreviewBlock }
